<template>
  <div class="wrap">
    <h2 class="common-header">{{ $t('88') }}</h2>
    <div class="by-content">
      <el-form :inline="true" :model="dataForm" ref="dataForm">
        <el-form-item :label="$t('73')">
          <el-input
            class="submitter"
            v-model="dataForm.submitter"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 在职状态 -->
        <el-form-item :label="$t('state')">
          <el-select
            v-model="dataForm.staff_state"
            @clear="clearAuditType"
            :placeholder="$t('74')"
            value-key="label"
            clearable
            multiple
          >
            <el-option v-for="item in onJobStates" :key="item.key" :label="item.value" :value="item.key"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('75')">
          <el-input v-model="dataForm.serial_no" clearable :placeholder="$t('75')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('77')">
          <date-picker
            style="display: inline-block; margin: 0"
            :date-type="'daterange'"
            :defaultTime="[]"
            :value-format="'yyyy-MM-dd'"
            :defaultValue="defaultDate"
            :chooseRange="chooseRange"
            @input="dataPickerSuccess"
          ></date-picker>
        </el-form-item>
        <!-- 完成时间 -->
        <el-form-item :label="$t('78')">
          <el-date-picker
            v-model="completeDate"
            :defaultTime="[]"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            align="center"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 审批类型 -->
        <el-form-item :label="$t('74')">
          <el-select
            v-model="dataForm.audit_type"
            @clear="clearAuditType"
            :placeholder="$t('74')"
            value-key="label"
            clearable
            multiple
          >
            <el-option v-for="item in typeArr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 实际发生时间 -->
        <el-form-item :label="$t('1408')">
          <el-date-picker
            v-model="actualOccurrence"
            :defaultTime="[]"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            :disabled="!dataForm.audit_type.length || dataForm.audit_type.length > 1"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 审批状态 -->
        <el-form-item :label="$t('79')">
          <el-select v-model="dataForm.state" :placeholder="$t('79')" clearable multiple>
            <el-option v-for="item in stateArr" :key="item.code" :label="item.value" :value="item.code"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="getTableList">{{ $t('80') }}</el-button>

          <el-button
            type="primary"
            plain
            @click="exportFn"
            :loading="exportLoading"
            :disabled="
              !(
                dataForm.create_date_end &&
                dataForm.create_date_start &&
                dataForm.audit_type &&
                dataForm.audit_type.length
              )
            "
            v-if="$p('menu.approval.search.export')"
            >{{ $t('77307511') }}</el-button
          >
          <el-button type="primary" plain @click="exportSearchFn">{{ $t('75111007') }}</el-button>
        </el-form-item>
      </el-form>
      <!--  -->
      <el-table
        :data="page.list"
        ref="table"
        v-load="tableLoading"
        border
        :loading-text="$t('989')"
        @sort-change="handlerSort"
      >
        <!-- 工号 -->
        <el-table-column
          prop="staff_code"
          :label="$t('25')"
          fixed="left"
          width="100"
          align="center"
          sortable="custom"
        ></el-table-column>
        <!-- 发起人 -->
        <el-table-column
          prop="staff_name"
          :label="$t('73')"
          fixed="left"
          width="200"
          align="center"
          sortable="custom"
        ></el-table-column>
        <!-- 在职状态 -->
        <el-table-column prop="state_txt" :label="$t('state')" width="200" align="center"></el-table-column>
        <!-- 审批类型 -->
        <el-table-column prop="type_label" :label="$t('74')" width="200" align="center"></el-table-column>
        <el-table-column prop="serial_no" :label="$t('75')" width="200" align="center"></el-table-column>
        <el-table-column prop="state_label" :label="$t('79')" width="200" align="center"></el-table-column>
        <el-table-column
          prop="created_at"
          :label="$t('77')"
          width="200"
          sortable="custom"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="final_approval_time"
          :label="$t('78')"
          width="200"
          sortable="custom"
          align="center"
        ></el-table-column>
        <el-table-column prop="actual_time" :label="$t('1408')" width="360" align="center"></el-table-column>
        <!-- 撤销理由 -->
        <el-table-column prop="re_cancel_reason" :label="$t('1028')" width="200" align="center"></el-table-column>
        <!-- 撤销时间 -->
        <el-table-column
          prop="re_cancel_approver_time"
          :label="$t('1033')"
          width="200"
          align="center"
        ></el-table-column>
        <!-- <el-table-column></el-table-column> -->
        <el-table-column :label="$t('70')" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="seeFn(scope.row)">
              {{ $t('64') }}
            </el-button>
            <!-- 作废按钮 6 已拒绝撤销 8 已取消撤销 -->
            <el-button
              type="text"
              :style="`${['6', '8'].includes(scope.row.state) && 'color: red;'}`"
              :disabled="!['6', '8'].includes(scope.row.state)"
              @click="openDisuseDialog(scope.row)"
              v-if="$p('menu.approval.search.edit')"
              >{{ $t('disuse') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :page-sizes="pageSizes"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :total="page.total"
          :current-page="page.currPage"
          :page-size="page.limit"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 导出更多 -->
    <ExportMore ref="more" :stateArr="stateArr" />
    <see-comp v-if="isSeeComp" ref="seeComp"></see-comp>
    <!-- 作废弹窗 -->
    <el-dialog :title="$t('disuse_reason')" :visible.sync="disuse.dialogVisible" width="30%">
      <el-input v-model="disuse.payload.disuse_reason" type="textarea" :rows="5" :maxlength="500" show-word-limit />
      <span slot="footer" class="dialog-footer">
        <el-button @click="disuse.dialogVisible = false">{{ $t('cancel_btn') }}</el-button>
        <el-button type="primary" :loading="disuse.submitLoading" @click="handleDisuse(disuse.payload)">{{
          $t('disuse')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { axiosRequest } from '@/util/axios-request'
import datePicker from '_c/date-picker'
import { util } from '@/util/util'
import { listFn, exportFn, configFn } from 'api/approval/search'
import seeComp from './see'
import { sysInfoFn } from 'api/org/per'
import ExportMore from './modal/export'

const defaultDate = [util.fmtDate('yyyy-MM-dd', util.getTime(-90)), util.fmtDate('yyyy-MM-dd', util.getTime(0))]

export default {
  components: {
    datePicker,
    seeComp,
    ExportMore
  },
  data() {
    return {
      exportLoading: false,
      completeDate: [],
      actualOccurrence: [], // 实际发生时间
      dataForm: {
        staff_state: '', // 在职状态
        create_date_start: '',
        create_date_end: '',
        finish_date_start: '',
        finish_date_end: '',
        audit_type: [] // 审批类型
      },
      typeArr: [],
      stateArr: [],
      // 在职状态
      onJobStates: [],
      pageSizes: [100, 50, 20],
      sort: '',
      dir: '',
      page: {
        list: [{}],
        currPage: 1,
        limit: 100,
        total: 0
      },
      chooseRange: 90,
      defaultDate,
      tableLoading: false,
      isSeeComp: false,
      // 作废业务相关数据
      disuse: {
        // 作废提交loading
        submitLoading: false,
        // 作废Dialog是否显示
        dialogVisible: false,
        // 作废相关提交参数
        payload: {
          audit_type: '',
          audit_id: '',
          disuse_reason: ''
        }
      }
    }
  },
  watch: {
    'disuse.dialogVisible'(visible) {
      if (!visible) {
        this.disuse.payload = {
          audit_type: '',
          audit_id: '',
          disuse_reason: ''
        }
      }
    }
  },
  mounted() {
    ;[this.dataForm.create_date_start, this.dataForm.create_date_end] = this.defaultDate
    this.getConfigFn()
    // 获取选项值
    this.sysInfoFn()
  },
  methods: {
    openDisuseDialog(row) {
      this.disuse.dialogVisible = true
      this.disuse.payload.audit_type = row.type
      this.disuse.payload.audit_id = row.audit_id
    },
    // 导出查询结果
    exportSearchFn() {
      this.$refs.more.init()
    },
    // 作废处理
    handleDisuse(data) {
      this.disuse.submitLoading = true
      axiosRequest({
        url: '/web/approval/disuse',
        method: 'POST',
        data
      })
        .then(res => {
          if (res.code === 1) {
            this.disuse.dialogVisible = false
            this.$message.success(this.$t('disuse_success'))
            this.getTableList()
          }
        })
        .catch(err => {
          throw err
        })
        .finally(() => {
          this.disuse.submitLoading = false
        })
    },
    // 获取在职状态
    async sysInfoFn() {
      const res = await sysInfoFn()
      this.onJobStates = res.data.state
    },
    // 排序
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.getTableList()
    },
    async getConfigFn() {
      const res = await configFn()
      if (res && res.code === 1) {
        this.typeArr = res.data.audit_type.map(v => ({
          label: v.value,
          value: v.code
        }))
        this.stateArr = res.data.state
        this.getTableList()
      }
    },
    async getTableList() {
      // loading 表格
      this.tableLoading = true
      listFn({
        ...this.dataForm,
        sort: this.sort, // 排序相关
        dir: this.dir,
        page_num: this.page.currPage,
        page_count: this.page.limit,
        finish_date_start: this.completeDate ? this.completeDate[0] : '',
        finish_date_end: this.completeDate ? this.completeDate[1] : '',
        actual_date_start: this.actualOccurrence ? this.actualOccurrence[0] : '',
        actual_date_end: this.actualOccurrence ? this.actualOccurrence[1] : ''
      })
        .then(res => {
          this.page.list = res.data.dataList
          this.page.total = res.data.pagination.total
        })
        .finally(() => (this.tableLoading = false))
      // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
    },
    dataPickerSuccess(val) {
      ;[this.dataForm.create_date_start, this.dataForm.create_date_end] = val || ['', '']
    },
    // 每页条数
    sizeChangeHandle(val) {
      this.page.limit = val
      this.getTableList()
    },
    // 切换 页
    currentChangeHandle(val) {
      this.page.currPage = val
      this.getTableList()
    },
    async exportFn() {
      this.exportLoading = true
      const res = await exportFn({
        ...this.dataForm,
        finish_date_start: this.completeDate ? this.completeDate[0] : '',
        finish_date_end: this.completeDate ? this.completeDate[1] : '',
        actual_date_start: this.actualOccurrence ? this.actualOccurrence[0] : '',
        actual_date_end: this.actualOccurrence ? this.actualOccurrence[1] : ''
      }).finally(() => (this.exportLoading = false))
      if (res && res.code === 1) window.open(res.data.object_url)
    },
    seeFn(item) {
      this.isSeeComp = true
      this.$nextTick(() => {
        this.$refs.seeComp.init(item)
      })
    },
    // 数据初始化
    clearAuditType() {
      this.actualOccurrence = []
    }
  }
}
</script>

<style lang="scss" scoped>
.submitter {
  min-width: 320px;
}
</style>
